import EditProfile from './components/EditProfile';
import EditPwd from './components/EditPwd';
import HasNewTermsAndConditions from './components/common/HasNewTermsAndConditions';
import MeterIndexDetail from './components/common/meterIndexDetail/MeterIndexDetail';
import MeterOnboardingWizard from './components/meterOnboarding/MeterOnboardingWizard';
import NoMatch from './components/NoMatch';
import Notifications from './components/notification/Notifications';
import Overview from './components/overview/Overview';
import OverviewMeterDetails from './components/overview/OverviewMeterDetails';
import Profile from './components/Profile';
import ProtectedRoute from './components/common/ProtectedRoute';
import Root from './Root';
import RouteErrorBoundary from './components/common/RouteErrorBoundary';
import SignIn from './components/SignIn';
import SignOut from './components/SignOut';
import SignUp from './components/SignUp';
import TermsAndConditions from './components/TermsAndConditions';
import { createBrowserRouter } from 'react-router-dom';

export const routes = {
  ROOT: { path: '/' },
  OVERVIEW: {
    path: '/overview',
    children: {
      OVERVIEW_DETAIL: { path: '/:id/:tabId' },
    },
  },
  METERS: {
    path: '/meters',
    children: {
      METERS_ADD: { path: '/add' },
      METERS_DETAIL: { path: '/:id' },
      METERS_INDEX_DETAIL: { path: '/index/:indexId' },
    },
  },
  TERMS_AND_CONDITIONS: { path: '/terms-and-conditions' },
  SIGN_IN: { path: '/sign-in' },
  SIGN_UP: { path: '/sign-up' },
  SIGN_OUT: { path: '/sign-out' },
  PROFILE: { path: '/profile' },
  EDIT_PROFILE: { path: '/edit-profile' },
  EDIT_PWD: { path: '/edit-pwd' },
  NOTIFICATIONS: { path: '/notifications' },

  withArgs: (route: string, args: Record<string, string | undefined>) =>
    route.replace(/:\w+/g, (match) => {
      return args[match] ?? '';
    }),
};

const router = createBrowserRouter([
  {
    path: '*',
    element: <NoMatch />,
  },
  {
    path: routes.ROOT.path,
    element: <Root />,
    errorElement: <RouteErrorBoundary hasHeader />,
    children: [
      {
        path: routes.OVERVIEW.path,
        element: (
          <ProtectedRoute>
            <HasNewTermsAndConditions>
              <Overview />
            </HasNewTermsAndConditions>
          </ProtectedRoute>
        ),
        children: [
          {
            path: `${routes.OVERVIEW.path}${routes.OVERVIEW.children.OVERVIEW_DETAIL.path}`,
            element: (
              <ProtectedRoute>
                <OverviewMeterDetails />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: routes.METERS.path,
        children: [
          {
            path: `${routes.METERS.path}${routes.METERS.children.METERS_ADD.path}`,
            element: (
              <ProtectedRoute>
                <MeterOnboardingWizard />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routes.METERS.path}${routes.METERS.children.METERS_DETAIL.path}${routes.METERS.children.METERS_INDEX_DETAIL.path}`,
            element: (
              <ProtectedRoute>
                <MeterIndexDetail />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: routes.PROFILE.path,
        element: (
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        ),
      },
      {
        path: routes.NOTIFICATIONS.path,
        element: (
          <ProtectedRoute>
            <Notifications />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: routes.TERMS_AND_CONDITIONS.path,
    element: <TermsAndConditions />,
    errorElement: <RouteErrorBoundary hasHeader />,
  },
  {
    path: routes.SIGN_IN.path,
    element: <SignIn />,
    errorElement: <RouteErrorBoundary hasHeader />,
  },
  {
    path: routes.SIGN_UP.path,
    element: <SignUp />,
    errorElement: <RouteErrorBoundary hasHeader />,
  },
  {
    path: routes.EDIT_PROFILE.path,
    element: <EditProfile />,
    errorElement: <RouteErrorBoundary hasHeader />,
  },
  {
    path: routes.EDIT_PWD.path,
    element: <EditPwd />,
    errorElement: <RouteErrorBoundary hasHeader />,
  },
  {
    path: routes.SIGN_OUT.path,
    element: <SignOut />,
    errorElement: <RouteErrorBoundary hasHeader />,
  },
]);

export default router;
